import React from 'react'
import textToIcon from '../helpers/textToIcon.js'

class Tile extends React.Component {
  constructor(props) {
    super(props)
  }

  fields() {
    const allFields = this.props.fields.filter(f => f.tile === true)
    const tileFieldsWithValues = this.props.values.fields
    if(typeof tileFieldsWithValues === 'undefined') return
    // match field labels with values for this service
    const fieldsWithValues = allFields.map(f => Object.assign(f, tileFieldsWithValues.find(valueField => f.key == valueField.key)))
    return fieldsWithValues.slice(0, this.props.tileFieldCount).map((field) => {
      return (
          field.key === 'peoples-choice' ? null :
              <div className="w-100 flex mb1" key={field.id}>
          <p className="fl mb1 fw6 small" dangerouslySetInnerHTML={{__html: field.label}}></p>
          {this.fieldValue(field)}
        </div>
        )
    })
  }

  fieldValue(field) {
    if(this.props.accessLevel === 'bronze') {
      return <a className="mla" href="#" onClick={this.props.displayCta}>
        <svg width="12px" height="22px" viewBox="0 0 19 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none">
            <g id="non-member-paid-copy-5" transform="translate(-930.000000, -451.000000)">
              <rect fill="#FFFFFF" x="0" y="0" width="1440" height="1297"></rect>
              <path d="M943.761017,460.482946 C943.761017,459.309549 943.791629,458.216171 943.754059,457.124043 C943.684486,455.098575 941.927073,453.49883 939.767527,453.453819 C937.438223,453.405058 935.58132,454.859144 935.408083,456.927123 C935.330161,457.854212 935.405996,458.791304 935.350337,459.721519 C935.315551,460.305404 935.506181,460.509202 936.187996,460.496699 C938.342672,460.45919 940.498739,460.482946 942.653415,460.482946 L943.761017,460.482946 Z M939.497584,472.999592 C936.727883,472.999592 933.958182,473.000842 931.188481,472.998967 C930.190108,472.998967 930.002957,472.842055 930.002261,471.979356 C929.999478,468.485422 929.998782,464.991489 930.002957,461.49818 C930.003653,460.646108 930.181064,460.494198 931.120995,460.482946 C932.659254,460.465442 932.652992,460.465442 932.660645,459.069494 C932.66969,457.520385 932.532631,455.962525 933.338982,454.495935 C934.672001,452.072249 937.701209,450.615662 940.529351,451.088897 C943.781889,451.633398 946.08545,453.850786 946.293474,456.70082 C946.370004,457.749188 946.343566,458.805682 946.326173,459.857801 C946.31852,460.305404 946.443056,460.514828 946.992682,460.489197 C949.263545,460.382922 948.988036,460.634231 948.990819,462.35838 C948.996385,465.540366 948.993602,468.723602 948.99221,471.905589 C948.991514,472.852058 948.832192,472.998967 947.806686,472.998967 C945.036985,473.000842 942.267284,472.999592 939.497584,472.999592 Z" id="Fill-1" fill="#252525"></path>
            </g>
          </g>
        </svg>
      </a>
    } else {
      return textToIcon(field, field.value, 'tile')
    }
  }

  ctaTile() {
    if(this.props.freeAccess == true) {
      return this.props.directoryFreeExplanationPartialTile
    } else {
      return this.props.lockedTileCta
    }
  }

  displayPeoplesChoice() {
    let recomms = this.props.values && this.props.values.recommendations;

    if (recomms && recomms.peoples_choice && this.props.accessLevel !== 'bronze') {
      return (
        <div className="tile-image-container relative mla">
          <a href="/articles/peoples-choice">
            <span
              className="badge-sprite badge-sprite--peoples-choice--with-text--small"
              aria-label="People's Choice."
            ></span>
          </a>
        </div>
      )
    } else {
      return null;
    }
  }

  displayPrice(values, price) {
    if(this.props.accessLevel === 'bronze') {
      return <div className="ph2 ph0-ns pb3 link mla block-get-access-copy flex flex-column fr w-20">
        <div className="lock"></div>
        <a className="underline small tc lh-copy a--black" href="/purchase/join">Unlock premium</a>
      </div>
    } else {
      return <div className="ph2 ph0-ns pb3 db mla fr">
        <h3 className="h4 mb0 numeric-font b price tr absolute right-0">{price}</h3>
        <p className="small mb0 fw6 pt1 sub-price tr mt3">{price.startsWith('$') ? this.props.service_payment_period_label : '\u00A0'}</p>
      </div>
    }

  }


  render() {
    if (this.props.isDonateCTA) {
      // "db" not "flex" - does not work on old iOS safaris
      return <article className="w-30-l w-100 ba pa3 pt2 ma3 mr0-ns mb0 b--light-silver br2 services-tile-animation db flex-column tile-element cta-tile-container tile-free" dangerouslySetInnerHTML={{__html: this.ctaTile()}}></article>
    }

    const values = this.props.values
    if(typeof values.calculations === 'undefined')
      values.calculations = []
    const priceWrapper = values.calculations.find((c) => Object.keys(c)[0] == this.props.filterKey)
    let price

    if(typeof priceWrapper !== 'undefined') {
      price = priceWrapper[this.props.filterKey]
      if (typeof price == 'undefined') {
        price = 'n/a';
      }
      if (!price.toString().replace(/\s/g, '').length) {
        price = 'n/a';
      }
      if (!isNaN(parseInt(price))) {
        price = `$${parseFloat(price).toFixed(2)}`
      }
    } else {
      price = 'n/a'
    }

    return (
      <article className='w-30-l w-100 ba pa3 pt2 ma3 mr0-ns mb0 b--light-silver br2 tile-background services-tile-animation flex flex-column tile-element'>
        <a className={`${this.props.accessLevel == 'bronze' ? 'pointer-disabled o-50' : ''} db link w-100 small tr pb2 remove outline-0`} href="#" value={values.id} onClick={this.props.handleRemoveItem}></a>
        <div className="tile-image-container relative mba">
          <img className="fl w-25 pr2" src={`${values.image}`} alt={values.brand + " logo"} />
          <a href={values.url} className="ph2 ph0-ns pb3 link db fl w-45 a--black a--no-decoration">
            <h3 className="h5 b mb0">{values.brand}</h3>
            <h3 className="fw5 small mt2 lh-title">{values.title}</h3>
          </a>
          {this.displayPrice(values, price)}
        </div>
        {this.displayPeoplesChoice()}
        <div className="w-100 mb2 mta">
          {this.fields()}
        </div>
        <a className="Button Button--blue Button--wide"
           href={values.url}>View details</a>
      </article>
      )
  }
}

export default Tile
